module.exports = __webpack_public_path__ + "assets/pay-method-card.9bbacc4a.svg";